/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * ---------------------------------------------------------------------------------------------
 */

import { makeStyles, tokens } from '@fluentui/react-components';

const links = {
  textDecorationLine: 'none',
  color: tokens.colorNeutralForeground3,
  fontSize: tokens.fontSizeBase200,
  lineHeight: '24px',
  cursor: 'pointer',
};

export const useStyles = makeStyles({
  container: {
    paddingLeft: '0.3rem',
    paddingRight: '0.3rem',
    paddingBottom: '0.3rem',
  },
  appLinkStyle: {
    ...links,
    '&:hover': {
      textDecorationLine: 'underline',
      textDecorationThickness: '1px',
    },
  },
  pageLinkStyle: {
    ...links,
    '&:hover': {
      color: tokens.colorNeutralForeground3,
      textDecorationThickness: '1px',
    },
  },
});
